import React, { createContext, useContext, useState, ReactNode } from 'react';
import { ClientContextInterface } from '../../../assets/interfaces/RBACInterface';

interface ClientPropsData {
    clientContextData: ClientContextInterface;
    setClientContextData: (ccData: ClientContextInterface) => void
}

const ClientContext = createContext<ClientPropsData | undefined>(undefined);

export const useClientContext = () => {
    const context = useContext(ClientContext);
    if (context === undefined) {
        throw new Error('useCategory must be used within a CategoryProvider');
    }
    return context;
};

interface ClientProviderProps {
    children: ReactNode;
}

export const ClientContextProvider: React.FC<ClientProviderProps> = ({ children }) => {
    const [clientContextData, setClientContextData] = useState<ClientContextInterface>({
        mode: "ADD",
        outletId: "",
        uuid: "",
        method: "POST",
    });
 
    return (
        <ClientContext.Provider value={{ clientContextData, setClientContextData }}>
            {children}
        </ClientContext.Provider>
    );
};

